import React, { useState } from "react"
import {

  Row,

  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Button,

} from "reactstrap"
import PropTypes from "prop-types"
import Invoice from "./invoice"
import InvoiceOrders from "../../components/Common/GenerateInvoice/index"
import InvoiceModal from "./invoiceModal"


const GenerateInvoice = props => {
  const { isOpen, toggle, orderObject } = props

  const [modal, setModal] = useState(false)
  
  const [rows, setRows] = useState([])
  const toggleModal = () => {
    setModal(!modal)
    // if(modal == true){
    // // setRows([])
    // }
  }
  
  const handlerows = (rows) => {
    setRows(rows);
  } 

  return (
    <React.Fragment>

      <Row>
        <Offcanvas
          isOpen={isOpen}
          direction="end"
          toggle={toggle}
        >
          <OffcanvasHeader toggle={toggle}>
            {orderObject.company + " - " + orderObject.userName}
          </OffcanvasHeader>
          <OffcanvasBody>

            <InvoiceOrders match={""} orderObject={orderObject} isOpen={isOpen} handlerows={handlerows} />
            <Button onClick={() => toggleModal()}>Generate Invoice</Button>
          </OffcanvasBody>
        </Offcanvas>
      </Row>

      <Row>
        <InvoiceModal isOpen={modal} toggle={toggleModal} processData={orderObject} invoiceItems={rows} />
      </Row>

    </React.Fragment>
  )
}
GenerateInvoice.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  orderObject: PropTypes.object
}

export default GenerateInvoice
